import apiClient from '../config/api';
import { extractErrorMessage } from '../utils/errorUtils';

export interface SendEmailRequest {
  to: string;
  subject: string;
  body?: string; // Optionnel : si non fourni, sera généré automatiquement côté backend
  pdfBase64: string;
  filename: string;
  fromEmail?: string; // Email professionnel de l'utilisateur
  fromName?: string; // Nom complet de l'utilisateur

  // ========== DONNÉES POUR GÉNÉRATION AUTOMATIQUE DU BODY ==========
  // Si ces champs sont fournis (et body absent), le body sera généré automatiquement côté backend

  // Données du client
  clientPrenom?: string;
  clientNom?: string;

  // Données du devis (pour emails de devis)
  devisNumero?: string;
  devisMontantTTC?: number;
  devisDateValidite?: string; // Format ISO date

  // Données de la facture (pour emails de facture)
  factureNumero?: string;
  factureMontantTTC?: number;
  factureDateEcheance?: string; // Format ISO date

  // Nom de l'entreprise (pour la signature)
  entreprise?: string;
}

export interface SendWhatsAppRequest {
  phoneNumber: string;
  message: string;
  pdfBase64?: string;
  filename?: string;
}

class EmailService {
  /**
   * Envoyer un email avec pièce jointe PDF
   */
  async sendEmail(request: SendEmailRequest): Promise<{ success: boolean; message: string }> {
    try {
      const response = await apiClient.post('/api/email/send', request);
      return response.data;
    } catch (error: any) {
      console.error('Erreur lors de l\'envoi de l\'email:', error);
      const errorMessage = extractErrorMessage(error, 'Erreur lors de l\'envoi de l\'email');
      throw new Error(errorMessage);
    }
  }

  /**
   * Envoyer un message WhatsApp (via API si disponible)
   */
  async sendWhatsApp(request: SendWhatsAppRequest): Promise<{ success: boolean; message: string }> {
    try {
      const response = await apiClient.post('/api/whatsapp/send', request);
      return response.data;
    } catch (error: any) {
      console.error('Erreur lors de l\'envoi WhatsApp:', error);
      const errorMessage = extractErrorMessage(error, 'Erreur lors de l\'envoi WhatsApp');
      throw new Error(errorMessage);
    }
  }
}

export default new EmailService();
